export function clean(props) {
    return Object.fromEntries(
        Object.entries(props).filter(([, v]) => {
            if (typeof v === "string") return true
            return typeof v === "number"
        })
    )
}
